import moment from "moment";
import { LEGACY_UI_VALUE, parseRange } from "@/components/report/desktop/reportQuery";

/**
 * Stanje magacina u adresi (hash router: /#/warehouse?t=purchase&from=…&to=…).
 * Danas i podrazumevani tab se izostavljaju; ostalo (magacini, dobavljači, filteri) živi u store-u.
 */
export const WAREHOUSE_QUERY = {
  tab: "t",
  from: "from",
  to: "to",
  legacy: "ui",
};

export const MANAGED_WAREHOUSE_QUERY = [WAREHOUSE_QUERY.tab, WAREHOUSE_QUERY.from, WAREHOUSE_QUERY.to];

export { LEGACY_UI_VALUE, parseRange };

const ISO = "YYYY-MM-DD";

/**
 * Brzi izbori perioda u magacinu: trebovanje se gleda unapred (sutra), dokumenti unazad (juče).
 * @param {moment.Moment|Date|string} [today]
 * @returns {Array<{ key: string, from: string, to: string }>}
 */
export const buildWarehousePeriodPresets = (today = moment()) => {
  const day = moment(today).startOf("day");
  const range = (from, to) => ({ from: from.format(ISO), to: to.format(ISO) });
  const lastMonth = day.clone().subtract(1, "month");
  return [
    { key: "today", ...range(day, day) },
    { key: "tomorrow", ...range(day.clone().add(1, "day"), day.clone().add(1, "day")) },
    { key: "yesterday", ...range(day.clone().subtract(1, "day"), day.clone().subtract(1, "day")) },
    { key: "this_week", ...range(day.clone().startOf("isoWeek"), day.clone().endOf("isoWeek")) },
    { key: "this_month", ...range(day.clone().startOf("month"), day.clone().endOf("month")) },
    { key: "last_month", ...range(lastMonth.clone().startOf("month"), lastMonth.clone().endOf("month")) },
  ];
};
